/**
 *
 * @module extensions
 */
define('toolkit/extensions/extensions', [
	'jquery'
], function ($){
	'use strict';

	if(!$.fn.display) {
		$.fn.extend({
			display: function (type) {
				if ((type !== void 0) && (typeof type !== 'string')) {
					type = !type ? 'none' : '';
				}

				return	this.css('display', type);
			}
		});
	}

});
